<div class="floor-plan-dialog-container">
  <h4>Attach one floor plan to this property</h4>
  <ng-container *ngIf="showAllFloorPlan">
    <div style="height: 500px; overflow: scroll;">
      <mat-radio-group [(ngModel)]="selection" (change)="radioChange($event)">
        <mat-radio-button *ngFor="let floorPlan of floorPlans; let i = index" [value]=floorPlan.id
          style="width: 100%; padding: 10px; border-bottom: 1px solid #f6f6f6">
          <div style="display: flex; align-items: center;">
            <div style="padding:0 10px">
              Floorplans
              <p style="color: #3C50E0; margin-top: 0; margin-bottom: 0; text-align: right">{{floorPlan.notes}}</p>
            </div>
            <div *ngFor="let image of floorPlan.images" style="display: flex; gap: 20px; overflow-x: scroll">
              <img style="width: 200px; height: 200px; border: 1px solid #ebebeb; object-fit: contain"
                [src]="encodeURI(SERVER_URL +'images/' + projectCode + '/floor_plans/' + image.fileName)">
            </div>
          </div>
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div style="display: flex; justify-content: space-between; padding-top: 10px">
      <button mat-button (click)="closeDialog()" class="cancel_button">Cancel</button>
      <button mat-button class="confirm_button" (click)="AttachFloorPlan()"
        [disabled]="!this.selection">Confirm</button>
    </div>
  </ng-container>
  <ng-container *ngIf="!showAllFloorPlan">
    <div>
      No floor plan exists yet!
      <p>Please go to [Floor plan] tab and create some.</p>
      <button mat-button (click)="closeDialog()" class="cancel_button">Ok, got it.</button>

    </div>
  </ng-container>



</div>